import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/buttons/Button.vue';
import InputGroup from '@/components/form/InputGroup.vue';
import IconMessageBlock from '@/components/info/IconMessageBlock.vue';
import { Icon } from '@/lib/enum/Icon';
import {
  scheduledBreaksAcceptableDuration,
  scheduledBreaksNoOverlap,
} from '@/lib/forms/customValidators/shiftSessionsValidators';
import { getErrorMessages } from '@/plugins/vuelidate';
import store from '@/store';
import { ScheduledBreakFormItemType } from '@/types/shiftSessionsForm';
import useVuelidate from '@vuelidate/core';
import { computed, reactive, watch } from 'vue';
import BreakDetailsItem from './BreakDetailsItem.vue';

/* PROPS */

export default /*#__PURE__*/_defineComponent({
  __name: 'BreakDetails',
  props: {
    showHeader: { type: Boolean, default: true },
    shiftStartTime: null,
    shiftEndTime: null,
    scheduledBreaks: null,
    updateBreaks: null,
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { showHeader: boolean, shiftStartTime: string, shiftEndTime: string, scheduledBreaks: ScheduledBreakFormItemType[], updateBreaks: (breaks: ScheduledBreakFormItemType[]) => void, disabled: boolean }



/* DATA */
const form = reactive({
  scheduledBreaks: props.scheduledBreaks,
});

const validators = {
  scheduledBreaks: {
    breaksNoOverlap: scheduledBreaksNoOverlap(() => props.shiftStartTime),
    breaksAcceptableDuration: scheduledBreaksAcceptableDuration(
      () => props.shiftStartTime,
      () => props.shiftEndTime,
    ),
  },
};

const v$ = useVuelidate(validators, form, { $autoDirty: true });

/* COMPUTED */
const defaultBreakLength = computed<number>(
  () => store.state.settings.scheduleSettings.defaultBreakLength,
);

// display error message only if inner forms have no validation errors
const displayErrorMessage = computed<boolean>(
  () =>
    !v$.value.$errors.some((error) => error.$property !== 'scheduledBreaks'),
);

/* METHODS */
const addBreak = () => {
  form.scheduledBreaks = [
    ...form.scheduledBreaks,
    {
      id: Date.now(),
      paid: false,
      durationInMinutes: defaultBreakLength.value,
      breakStartTimeEnabled: false,
      startTime: '',
    },
  ];
};

const removeBreak = (id: number) => {
  form.scheduledBreaks = form.scheduledBreaks.filter((b) => b.id !== id);
};

/* WATCH */
watch(form, (value) => {
  // in case we manage scheduled breaks in children components only
  if (!v$.value.scheduledBreaks.$dirty) {
    v$.value.scheduledBreaks.$touch();
  }
  props.updateBreaks(value.scheduledBreaks);
});

return { __sfc: true,props, form, validators, v$, defaultBreakLength, displayErrorMessage, addBreak, removeBreak, Button, InputGroup, IconMessageBlock, Icon, getErrorMessages, BreakDetailsItem }
}

})